<template>
  <material-card
    :title="$t('components.vuematerialdashboard.core.appbar.claims_reports')"
    color="rgb(0, 168, 215)"
    icon="attach_money"
  >
    <v-container fluid v-if="options">
      <v-form>
        <v-row>
          <v-col>
            <v-autocomplete
              name="plans"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :label="$t('globals.plan')"
              v-model="selected.plans"
              :items="plans"
              :item-text="planDescription"
              item-value="Id"
              hide-details
              clearable
              return-object
              outlined
              multiple
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="selected.paymentMethods"
              :items="options.Enums.PaymentMethod"
              :label="$t('headers.claims_payments.PaymentMethod')"
              outlined
              dense
              multiple
              :item-text="(item) => $t('enums.' + item)"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col>
            <!-- <v-date-picker
              :label="$t('components.guides.search_per_benefit.date_range')"
              v-model="dateRange"
              range
            ></v-date-picker> -->
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  clearable
                  v-model="dateRangeText"
                  :label="$t('components.guides.search_per_benefit.date_range')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[$rules.required]"
                  class="required"
                ></v-text-field>
              </template>
              <v-date-picker range v-model="selected.dates"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
      <div style="margin-right:20px;margin-top: 10px;">
        <v-menu
          bottom
          left
          :disabled="provider === null || provider === undefined"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="primary" dark>
              <v-icon>more_vert</v-icon>
              {{ $t("globals.export") }}
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="exportHandler('PaidClaimsRegister')">
              <v-list-item-title>
                {{
                  $t("components.claims.claims_reports.paid_claims_register")
                }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportHandler('PaidClaimsSummary')">
              <v-list-item-title>
                {{ $t("components.claims.claims_reports.paid_claims_summary") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportHandler('ClaimStatistics')">
              <v-list-item-title>
                {{ $t("components.claims.claims_reports.claims_statistics") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="exportHandler('All')">
              <v-list-item-title>
                {{ $t("globals.all") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-container>
    <div v-else>
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
    <div>
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </div>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <error-handler :error="error" />
  </material-card>
</template>

<script>
import getClaimsPaymentsHeaders from "../../headers/ClaimsPayments";
import { ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import { translate2 } from "@/trans2";
import moment from "moment";
import { saveAs } from "file-saver";

export default {
  components: {
    ErrorHandler,
  },
  data: function() {
    return {
      provider: undefined,
      error: null,
      selected: {
        plans: [],
        paymentMethods: [],
        dates: [],
      },
      dateMenu: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("common", ["plans", "settings", "claimsPlan"]),
    ...mapGetters("plansMembers", ["options"]),
    dateRangeText: {
      get: function() {
        return this.selected.dates.join(" ~ ");
      },
      set: function(newValue) {
        this.selected.dates = [];
      },
    },
  },
  mounted() {
    this.selected.dates = [
      moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ];
    this.loadUserPlans();
    if (this.options) {
      this.provider = undefined;
      this.$nextTick(() => {
        this.loadPlanData();
      });
    }
  },
  watch: {
    selected: {
      handler(v) {
        if (this.options) {
          if (v) {
            this.provider = undefined;
            this.$nextTick(() => {
              this.loadPlanData();
            });
          }
        }
      },
      deep: true,
    },
    options: {
      handler(v) {
        if (v) {
          this.provider = undefined;
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
  },
  methods: {
    ...mapActions("auth", ["login", "silentRefresh"]),
    ...mapActions("plansMembers", ["getUserPlans", "getPlan", "getMemberInfo"]),
    ...mapActions("common", ["setPlans"]),
    ...mapActions("claims", ["exportPayments"]),
    ...mapActions("documentsService", ["getFile"]),
    planDescription(plan) {
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    async loadUserPlans() {
      try {
        var usr = await this.silentRefresh();
        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.setPlans(
            plans.map((o) => {
              o.Name = o.Current.Name;
              o.Description = o.Current.Description;
              o.Translations = o.Current.Translations;
              return o;
            })
          );
        }
      } catch (error) {
        console.log("selectPlan: silent refresh error: ", error);
        this.login();
      }
    },
    loadPlanData() {
      const planFilters = [];
      const paymentMethodFilters = [];
      let dateFilter = null;
      let providerFilter = null;
      let url = `${this.settings.APIURL}claim-payments`;
     
        if (
          this.selected.plans !== null &&
          this.selected.plans !== undefined &&
          this.selected.plans.length > 0
        ) {
          for (let plan of this.selected.plans) {
            planFilters.push(`ClaimSubmission/PlanId eq ${plan.Id}`);
          }
        }
      
      if (
        this.selected.paymentMethods !== null &&
        this.selected.paymentMethods !== undefined &&
        this.selected.paymentMethods.length > 0
      ) {
        for (let paymentMethod of this.selected.paymentMethods) {
          paymentMethodFilters.push(
            `ClaimSubmission/PaymentMethod eq '${paymentMethod}'`
          );
        }
      }
      if (
        this.selected.dates !== null &&
        this.selected.dates !== undefined &&
        this.selected.dates.length === 2
      ) {
        dateFilter = `(PaymentBatch/IssuedAt ge ${
          this.selected.dates[0]
        } and PaymentBatch/IssuedAt le ${
          this.selected.dates[1]
        }) and (CancelledAt eq null or CancelledAt gt ${
          this.selected.dates[1]
        })`;
      } else {
        return;
      }
      const filters = [];
      if (planFilters.length > 0) {
        filters.push(planFilters.join(" or "));
      }
      if (paymentMethodFilters.length > 0) {
        filters.push(paymentMethodFilters.join(" or "));
      }
      
      filters.push(dateFilter);
      
      if (filters.length > 0) {
        providerFilter = filters.map((o) => `(${o})`).join(" and ");
      }
      if (providerFilter !== null) {
        this.provider = new ODataProvider(
          this.$axiosHttp,
          url,
          getClaimsPaymentsHeaders(this.options.Enums, false)
        );
        this.provider.filter = providerFilter;
      }
    },
    async exportHandler(paymentType) {
      try {
        this.loading = true;
        const data = (await this.exportPayments({
          payload: {
            ClaimReportType: paymentType,
            PlanIds: this.selected.plans.map((o) => o.Id),
            PaymentMethods: this.selected.paymentMethods,
            StartDate:
              this.selected.dates.length === 2
                ? this.formatDate(this.selected.dates[0])
                : null,
            EndDate:
              this.selected.dates.length === 2
                ? this.formatDate(this.selected.dates[1])
                : null,
          },
        })).data;
        for (const f of data) {
          const fileId = f.Id;
          const fileName = f.Name;

          const file = (await this.getFile(fileId)).data;
          const blob = this.$files.b64toBlob(file);
          saveAs(blob, fileName);
        }
        // this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    formatDate(d) {
      const [date, time] = d.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}T00:00:00.000Z`;
    },
  },
};
</script>
